import { memo } from 'react';
import { Handle, Position, NodeProps } from '@xyflow/react';

interface CodeBlockNodeData {
  label: string;
  description?: string;
  language?: string;
}

export const CodeBlockNode = memo(function CodeBlockNode({
  data,
  selected,
}: NodeProps) {
  const nodeData = data as unknown as CodeBlockNodeData;

  return (
    <div
      className={`px-4 py-3 rounded-lg border-2 bg-gray-50 min-w-[150px] ${
        selected ? 'border-primary shadow-lg' : 'border-gray-300'
      }`}
    >
      <Handle type="target" position={Position.Top} className="!bg-gray-500" />

      <div className="flex items-center gap-2">
        <span className="text-xl">📝</span>
        <div>
          <div className="font-semibold text-sm">{nodeData.label}</div>
          {nodeData.language && (
            <div className="text-xs text-muted-foreground">
              {nodeData.language}
            </div>
          )}
          {nodeData.description && (
            <div className="text-xs text-muted-foreground mt-1">
              {nodeData.description}
            </div>
          )}
        </div>
      </div>

      <Handle type="source" position={Position.Bottom} className="!bg-gray-500" />
    </div>
  );
});
